import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

bootstrapApplication(AppComponent, {
  ...appConfig,

  providers: [
    provideZoneChangeDetection(),
    ...(appConfig.providers ?? []),

    // Load interceptors from DI (required for class-based interceptors)
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
